import React, { useEffect, useState } from 'react';
import { getExpenses } from '~/services/hooks/expenses';
import { Button, Flex, Table as TableAntd } from 'antd';
import { FaPlus } from 'react-icons/fa';
import Strong from '~/components/Strong';
import { useCheckAuth } from '~/components/Can/checkAuth';
import { FieldArray } from 'formik';
import { Table } from '~/components/Table';
import { expensesEventsColumns } from '~/tables/espensesEvents';
import { formatPrice, parsePrice } from '~/Utils/format';
import errorHandler from '~/Utils/errorHandler';

export default function ExpenseModal({ visible, values, setFieldValue, setLoading, t, errors, eventRevenues }) {
  const authCheck = useCheckAuth();
  const [expenses, setExpenses] = useState([]);

  const fetchExpenses = async () => {
    setLoading(true);
    try {
      const expenses = await getExpenses('', 'no-paginated');
      setExpenses(expenses);
    } catch (error) {
      console.error(error);
      errorHandler(error);
    }
    setLoading(false);
  };

  const fluidPermissions = () => {
    if (eventRevenues) {
      return !eventRevenues;
    }
    return authCheck('@events/expensesEdit');
  };

  useEffect(() => {
    if (visible) {
      fetchExpenses();
    }
  }, [visible]);

  return (
    <>
      <FieldArray name={`event_expenses`}>
        {({ push, remove }) => (
          <Table
            dataSource={values?.event_expenses?.map((eventExpenses, index) => ({
              ...eventExpenses,
              key: index,
              remove,
            }))}
            columns={expensesEventsColumns(expenses, errors, fluidPermissions, values, setFieldValue)}
            pagination={false}
            size="small"
            rowClassName={() => 'editable-row'}
            bordered
            empty={false}
            summary={() => {
              const totals = values?.event_expenses?.reduce(
                (acc, ee) => {
                  acc.priceTotal += parsePrice(ee.price_total);
                  acc.amountTotal += parsePrice(ee.amount);

                  return acc;
                },
                {
                  priceTotal: 0,
                  amountTotal: 0,
                }
              );

              return (
                <>
                  <TableAntd.Summary.Row>
                    <TableAntd.Summary.Cell>
                      <Flex style={{ height: '100%' }} align="flex-start" justify="center">
                        <Button
                          color="primary"
                          title="Adicionar despesa"
                          size="small"
                          onClick={() =>
                            push({
                              event_id: values.id,
                              amount: 0,
                              price_unit: 0,
                              price_total: 0,
                              expense: { id: null },
                            })
                          }
                          style={{ width: '30px' }}
                          disabled={!fluidPermissions()}
                        >
                          <FaPlus />
                        </Button>
                      </Flex>
                    </TableAntd.Summary.Cell>
                  </TableAntd.Summary.Row>
                  <TableAntd.Summary.Row style={{ backgroundColor: '#d6d6d6' }}>
                    <TableAntd.Summary.Cell>
                      <Strong>{t('TOTAL')}</Strong>
                    </TableAntd.Summary.Cell>
                    <TableAntd.Summary.Cell>{totals.amountTotal}</TableAntd.Summary.Cell>
                    <TableAntd.Summary.Cell />
                    <TableAntd.Summary.Cell>{formatPrice(totals.priceTotal)}</TableAntd.Summary.Cell>
                    <TableAntd.Summary.Cell />
                  </TableAntd.Summary.Row>
                </>
              );
            }}
          />
        )}
      </FieldArray>
    </>
  );
}
